import React, { FC }     from "react";
import { useDispatch }   from "react-redux";
import { Button, Icon }  from "semantic-ui-react";
import GetRecordTemplate from "../../../../application/usecase/record/template/GetRecordTemplate";
import RecordTemplateId  from "../../../../domain/record/template/RecordTemplateId";
import RouterDispatcher  from "../../../../infrastructure/redux/router/RouterDispatcher";

interface Props {
  id: RecordTemplateId;
}

const RecordTemplateEditButton: FC<Props> = (props: Props) => {
  const getRecordTemplate: GetRecordTemplate = new GetRecordTemplate(useDispatch());
  const routerDispatcher: RouterDispatcher = new RouterDispatcher(useDispatch());
  return (
    <>
      <Button
        icon
        labelPosition="left"
        onClick={ () => {
          getRecordTemplate.execute(props.id);
          routerDispatcher.recordTemplateEdit();
        } }
      >
        <Icon name="edit"/>
        編集する
      </Button>
    </>
  );
};

export default RecordTemplateEditButton;
